<template>
  <div id="page-add-category">
    <div class="vx-row py-6">
      <div class="vx-col lg:w-1/4 sm:w-1/4" :key="i" v-for="(cat, i) in Object.keys(taxes)">
        <div class="vx-row px-2 py-1">
          <vs-input
            icon="icon icon-percent"
            :value="taxes[cat].tax_per"
            @input="
              (value) =>
                setTax({
                  type,
                  value,
                  category: cat
                })
            "
            type="number"
            step="0.01"
            icon-pack="feather"
            icon-after="true"
            class="w-full"
            :label="capitalizeFirstLatter(cat)"
            :name="capitalizeFirstLatter(cat)"
            max-number="100"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has(capitalizeFirstLatter(cat))">{{ errors.first(capitalizeFirstLatter(cat)) }}</span>
        </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
            class="mr-2 vs-con-loading__container"
            v-if="checkPermissionByIds([permissions.TAX_EDIT]) || checkPermissionByIds([permissions.TAX_ADD])"
            id="add-tax-button"
            type="relief"
            @click="save_changes"
            :disabled="!validateForm || loading"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import { weightMixins } from '@/utils/weightType'

export default {
  name: 'TaxSetting',

  props: {
    type: {
      type: String,
      required: true
    },
    taxMode: {
      type: String
    }
  },

  mixins: [weightMixins],

  mounted() {
    this.getTaxData()
  },

  computed: {
    ...mapState('setting', { loading: 'loading', taxUpdate: 'taxes' }),
    ...mapState('permission', ['permissions']),
    ...mapGetters('setting', ['getTax']),
    ...mapGetters('auth', ['checkPermissionByIds']),

    validateForm() {
      return !this.errors.any()
    },

    taxes() {
      return this.taxUpdate[this.type] || []
    }
  },
  methods: {
    ...mapActions('setting', { insertTax: 'taxAdd', getTaxData: 'getTaxData' }),
    ...mapMutations('setting', { setTax: 'setTax' }),

    async save_changes() {
      if (!this.taxMode) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please select Tax Mode',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        return false
      }

      if (!(await this.$validator.validate())) {
        return false
      }
      try {
        const { message } = await this.insertTax({
          tax_name: this.type,
          tax_mode: this.taxMode,
          categoryWiseTaxe: Object.keys(this.taxes).map((x) => ({ categoryId: this.taxes[x].categoryId, tax_per: this.taxes[x].tax_per }))
        })

        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    capitalizeFirstLatter(s) {
      if (typeof s !== 'string') return ''
      return s
        .split('_')
        .map((e) => e.charAt(0).toUpperCase() + e.slice(1))
        .join(' ')
    }
  },
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#add-tax-button',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#add-tax-button > .con-vs-loading')
      }
    }
  }
}
</script>
